<template>
	<div style="border: 1px solid #ccc;padding:15px;background-color: #f5f5f5;">
		<div style="padding: 15px;background-color: #fff;" class="boxnumber">
			<div style="display: flex;">
				<label style="margin-right: 10px;line-height:40px;">副标题：</label>
				<el-input type="textarea" rows="3" placeholder="请输入内容" style="width:90%;" v-model="newsdata.description"></el-input>
			</div>
			<div style="display: flex;" v-if="newsdata.tag == '介绍'">
				<label style="margin-right: 10px;line-height:40px;">介绍：</label>
				<el-input type="textarea" rows="8" placeholder="请输入内容" style="width:90%;" v-model="newsdata.introduce"></el-input>
			</div>
			<div style="display: flex;" v-if="newsdata.tag == '介绍'">
				<label style="margin-right: 10px;line-height:40px;">上传视频：</label>
				<el-upload
					class="avatar-uploader"
					style="margin: 20px;padding: 5px;border-radius:15px;height:50px;"
				  :action="$ips+'/common/upfile'"
				  :on-success="upload"
				  multiple
				  :limit="1"
				  >
				  <el-button size="small" type="primary">点击上传视频</el-button>
				</el-upload>
				<!-- <el-upload class="avatar-uploader"
					style="border: 1px solid #ebebeb;margin: 20px;padding: 5px;border-radius:15px;"
					
					:show-file-list="false"  
					>
					<video v-if="newsdata.videourl" :src="newsdata.videourl" class="avatar"></video>
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload> -->
			</div>
			<div style="display: flex;justify-content: center;">
				<el-button type="primary" style="margin: 15px 0;" @click="updatanews">编辑</el-button>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue'
	export default Vue.extend({
		data() {
			return {
				newsdata: {}
			}
		},
		methods: {
			updatanews() {
				//  编辑新闻
				if (this.newsdata.introduce == "" || this.newsdata.description == '') {
					this.$message({
						showClose: true,
						message: '请填写全部内容',
						type: 'error'
					});
				} else if (this.newsdata.videourl == '') {
					// 未上传图片
					this.$message({
						showClose: true,
						message: '请上传视频',
						type: 'error'
					});
				} else {
					let that = this
					this.$confirm('确定要编辑吗', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then((res1) => {
						console.log(res1);
						if(res1 == 'confirm'){
							console.log('确认');
							that.newsdata.updatatime = that.$gettime()
							that.$post("/index/updatakronointroduce",that.newsdata).then(res=>{
								if(res.data=='编辑成功'){
									that.$message({
										type: 'success',
										message: '编辑成功!'
									});
								}else{
									that.$message({
										type: 'error',
										message: '编辑失败!'
									});
								}
							})
						}else{
							console.log('取消');
							this.$message({
								type: 'info',
								message: '已取消'
							});
						}
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});
				}
			},
			upload(e) {
				console.log(e);
				if (e.data.url) {
					this.newsdata.videourl = e.data.url
				}
			}
		},
		mounted() {
			this.$get('/index/getkronointroduce',{
				id:this.$route.params.id
			}).then(res=>{
				this.newsdata = res.data[0]
			})
		}
	})
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #a5a5a5;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.boxnumber div{
		margin: 10px auto;
		
	}
	.boxnumber div label{
		width:100px;
	}
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>